/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mode_ClassicInputs */

const bn_mode_classic = /** @type {(inputs: Mode_ClassicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ক্লাসিক`)
};

const de_mode_classic = /** @type {(inputs: Mode_ClassicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klassiker`)
};

const el_mode_classic = /** @type {(inputs: Mode_ClassicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Κλασσικός`)
};

const en_mode_classic = /** @type {(inputs: Mode_ClassicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Classic`)
};

const es_mode_classic = /** @type {(inputs: Mode_ClassicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clásico`)
};

const fr_mode_classic = /** @type {(inputs: Mode_ClassicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Classique`)
};

const hi_mode_classic = /** @type {(inputs: Mode_ClassicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`क्लासिक`)
};

const hu_mode_classic = /** @type {(inputs: Mode_ClassicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klasszikus`)
};

const id_mode_classic = /** @type {(inputs: Mode_ClassicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klasik`)
};

const it_mode_classic = /** @type {(inputs: Mode_ClassicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Classico`)
};

const ja_mode_classic = /** @type {(inputs: Mode_ClassicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`クラシック`)
};

const ko_mode_classic = /** @type {(inputs: Mode_ClassicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`권위 있는`)
};

const nl_mode_classic = /** @type {(inputs: Mode_ClassicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klassiek`)
};

const pl_mode_classic = /** @type {(inputs: Mode_ClassicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klasyczny`)
};

const pt_mode_classic = /** @type {(inputs: Mode_ClassicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clássico`)
};

const ru_mode_classic = /** @type {(inputs: Mode_ClassicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Классический`)
};

const sv_mode_classic = /** @type {(inputs: Mode_ClassicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klassisk`)
};

const tr_mode_classic = /** @type {(inputs: Mode_ClassicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klasik`)
};

const uk_mode_classic = /** @type {(inputs: Mode_ClassicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`класичний`)
};

const vi_mode_classic = /** @type {(inputs: Mode_ClassicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cổ điển`)
};

const zh_mode_classic = /** @type {(inputs: Mode_ClassicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`经典的`)
};

const zh_hant_mode_classic = /** @type {(inputs: Mode_ClassicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`經典的`)
};

/**
* | output |
* | --- |
* | "Classic" |
*
* @param {Mode_ClassicInputs} inputs
* @param {{ locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }} options
* @returns {LocalizedString}
*/
export const mode_classic = /** @type {((inputs?: Mode_ClassicInputs, options?: { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mode_ClassicInputs, { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "bn") return bn_mode_classic(inputs)
	if (locale === "de") return de_mode_classic(inputs)
	if (locale === "el") return el_mode_classic(inputs)
	if (locale === "en") return en_mode_classic(inputs)
	if (locale === "es") return es_mode_classic(inputs)
	if (locale === "fr") return fr_mode_classic(inputs)
	if (locale === "hi") return hi_mode_classic(inputs)
	if (locale === "hu") return hu_mode_classic(inputs)
	if (locale === "id") return id_mode_classic(inputs)
	if (locale === "it") return it_mode_classic(inputs)
	if (locale === "ja") return ja_mode_classic(inputs)
	if (locale === "ko") return ko_mode_classic(inputs)
	if (locale === "nl") return nl_mode_classic(inputs)
	if (locale === "pl") return pl_mode_classic(inputs)
	if (locale === "pt") return pt_mode_classic(inputs)
	if (locale === "ru") return ru_mode_classic(inputs)
	if (locale === "sv") return sv_mode_classic(inputs)
	if (locale === "tr") return tr_mode_classic(inputs)
	if (locale === "uk") return uk_mode_classic(inputs)
	if (locale === "vi") return vi_mode_classic(inputs)
	if (locale === "zh") return zh_mode_classic(inputs)
	return zh_hant_mode_classic(inputs)
});